import { dayLabel, toDay } from './dates';

// Ce qu'un changement d'itération touche (roadmap, budget) et sa description pour la fenêtre du motif.

const BUDGET_FIELDS = ['forecast_ca_eur', 'forecast_time_hours', 'forecast_purchase_eur'];

const number = (value) => Number(value || 0).toLocaleString('fr-FR', { maximumFractionDigits: 0 });
const FORMATS = {
  forecast_ca_eur: (v) => `${number(v)} €`,
  forecast_time_hours: (v) => `${number(v)} h`,
  forecast_purchase_eur: (v) => `${number(v)} €`,
};
const LABELS = { start_date: 'Début', end_date: 'Fin', forecast_ca_eur: 'CA', forecast_time_hours: 'Heures', forecast_purchase_eur: 'Achats' };

export const shortDay = (iso) => {
  const day = toDay(iso);
  return day == null ? '—' : dayLabel(day);
};

/** { keys, title, lines } d'une modification d'itération : domaines touchés et ce qui change, en clair. */
export const describeIterationChange = (before, fields) => {
  const names = Object.keys(fields || {});
  const keys = [...new Set(names.map((name) => (BUDGET_FIELDS.includes(name) ? 'budget' : 'roadmap')))];
  const name = before?.name || 'l’itération';
  const lines = names.map((field) => {
    const from = before?.[field];
    const to = fields[field];
    if (field === 'start_date' || field === 'end_date') return `${LABELS[field]} : ${shortDay(from)} → ${shortDay(to)}`;
    if (FORMATS[field]) return `${LABELS[field]} : ${from == null || from === '' ? '—' : FORMATS[field](from)} → ${FORMATS[field](to)}`;
    if (field === 'name') return `Nouveau nom : « ${to} »`;
    if (field === 'description') return 'Vision de l’itération modifiée';
    return null;
  }).filter(Boolean);
  const budgetOnly = keys.length === 1 && keys[0] === 'budget';
  return { keys, title: budgetOnly ? `Budget de l’itération « ${name} »` : `Modifier l’itération « ${name} »`, lines };
};

const WHEN = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });

/** « 20 oct., 14:05 » pour un horodatage UTC du serveur. */
export const changeWhen = (iso) => {
  const date = iso ? new Date(String(iso).endsWith('Z') ? iso : `${iso}Z`) : null;
  return date && !Number.isNaN(date.getTime()) ? WHEN.format(date) : '';
};
